// GDPR Cookie Requirements by Country
const cookieRequirementCountries = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "GB",
  "CA",
  "AU",
  "NO",
  "SZ",
];

// COOKIES MODAL LOGIC WITH CATEGORY CONSENT
function getBannerEl() {
  return document.querySelector(".cookies-banner__wrapper");
}

function getCustomizeEl() {
  return document.querySelector(".cookies-customize__wrapper");
}

function setCookieConsent() {
  // Set a simple consent cookie that expires in 1 year
  const expires = new Date();
  expires.setTime(expires.getTime() + 365 * 24 * 60 * 60 * 1000);
  document.cookie = `cookie_consent=accepted;expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function hideBanner() {
  const banner = getBannerEl();
  window.cookieBannerVisible = false;
  document.dispatchEvent(new Event("cookieBannerHidden"));
  if (banner) {
    banner.classList.remove("show");
    document.body.classList.remove('cookie-banner--shown')
  }
}

function showBanner() {
  const banner = getBannerEl();
  window.cookieBannerVisible = true;
  if (banner) {
    banner.classList.add("show");
    document.body.classList.add('cookie-banner--shown')
  }
}

function showCustomize() {
  const customize = getCustomizeEl();
  const banner = getBannerEl();

  if (customize) customize.classList.add("show");
  if (banner) banner.classList.remove("show");
}

function hideCustomize() {
  const customize = getCustomizeEl();
  if (customize) customize.classList.remove("show");

  document.dispatchEvent(new Event("cookieBannerHidden"));
}

// --- Shopify Consent Wrappers ---
function setShopifyConsent(consentObj) {
  if (window.Shopify && window.Shopify.customerPrivacy) {
    window.Shopify.customerPrivacy.setTrackingConsent(consentObj, () => {
      console.log("Consent captured:", consentObj);
    });
  }
}

// Accept all categories
function handleAcceptAll() {
  const consentObj = {
    analytics: true,
    marketing: true,
    preferences: true,
  };

  setCookieConsent();
  setShopifyConsent(consentObj);
  hideBanner();
  hideCustomize();
}

// Reject all categories
function handleRejectAll() {
  const consentObj = {
    analytics: false,
    marketing: false,
    preferences: false, // functional is technically required, but false disables optional prefs
  };

  setCookieConsent();
  setShopifyConsent(consentObj);
  hideBanner();
  hideCustomize();
}

// Save based on checkboxes
function handleSavePreferences() {
  const statistical = document.getElementById("statistical-cookies")?.checked;
  const advertising = document.getElementById("advertising-cookies")?.checked;
  const functional = document.getElementById("functional-cookies")?.checked;

  const consentObj = {
    analytics: !!statistical, // statistical analysis
    marketing: !!advertising, // advertising + social
    preferences: !!functional, // functional cookies (non-optional, always true ideally)
  };
  setCookieConsent();
  setShopifyConsent(consentObj);
  hideCustomize();
}

// --- Initialization ---
function initCookieModal() {
  // Wire events
  document
    .querySelectorAll(".cookies-banner__accept")
    .forEach((btn) => btn.addEventListener("click", handleAcceptAll));

  const rejectBtn = document.querySelector(".cookies-banner__reject");
  if (rejectBtn) rejectBtn.addEventListener("click", handleRejectAll);

  const customBtn = document.querySelector(".cookies-banner__custom");
  if (customBtn) customBtn.addEventListener("click", showCustomize);

  const closeBtns = document.querySelectorAll(
    ".cookies-banner__close, .cookies-customize__close"
  );
  closeBtns.forEach((btn) =>
    btn.addEventListener("click", () => {
      hideBanner();
      hideCustomize();
    })
  );

  const saveBtn = getCustomizeEl()?.querySelector(".cookies-banner__accept");
  if (saveBtn) saveBtn.addEventListener("click", handleSavePreferences);
}

// --- Country requirement check ---
function shouldShowCookieBanner(countryCode) {
  return cookieRequirementCountries.includes(countryCode);
}

async function initConsentFlow() {
  // If consent already given, skip
  if (getCookie("cookie_consent")) {
    hideBanner();
    hideCustomize();
    document.dispatchEvent(new Event("cookieBannerHidden"));
    return;
  }

  showBanner();
  initCookieModal();
}

// --- Entry point ---
document.addEventListener("DOMContentLoaded", () => {
  if (Shopify.designMode) return;

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      (error) => {
        if (error)
          console.error("Error loading Shopify consent tracking:", error);
        initConsentFlow();
      }
    );
  } else {
    initConsentFlow();
  }
});
